var wrapInArray = function wrapInArray(data) {
  var newData = data;
  if (!Array.isArray(data)) {
    newData = [data];
  }
  return newData;
};
export default wrapInArray;
//# sourceMappingURL=wrapInArray.js.map